import { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import Row from "react-bootstrap/Row";
import "../../assets/css/scss/main.css";
import RightSideBanner from "./RightSideBanner";
import { Link, useNavigate } from "react-router-dom";
import { EmailCheck, UserReg } from "../../redux/auth-reducer/auth-service";
import { signUpMessage } from "../../utils/helper/emailVerification";
import { toast } from "react-toastify";
import validator from "validator";
import { NAME_PATTERN, isValidName } from "../../utils/helper/names";
import {
  CONFIRM_PASSWORD_REQUIRED,
  PASSWORDS_MISMATCH,
  PASSWORD_HINT,
  emailError,
  isValidEmail,
  isValidPassword,
  passwordError,
  passwordsDiffer,
  personNameError,
} from "../../utils/helper/validation";
import { PasswordToggle } from "../../CommonComponent/PasswordToggle";
import { BackButton } from "../../CommonComponent/BackButton";

function UserRegistration() {
  const [validated, setValidated] = useState(false);
  const navigate = useNavigate();
  let [visible, setVisible] = useState(false);
  let [visiblePass, setVisiblePass] = useState(false);
  const [isValid, setIsValid] = useState(true);
  const [firstNameError, setFirstNameError] = useState(true);
  const [lastNameError, setLastNameError] = useState(true);
  const [message, setMessage] = useState("");
  const [err, setErr] = useState("");
  const [errMessage, setErrMessage] = useState(false);
  const [val, setVal] = useState();

  const [regForm, setRegForm] = useState({
    firstName: "",
    lastName: "",
    emailId: "",
    password: "",
    confirmPassword: "",
  });

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    setValidated(true);

    // #108: one pass over every field, nothing sent until all of them pass. The old gate below
    // checked only the email and the names - so a bad password or a mismatch went to the server,
    // which refuses one thing per round trip - and it rejected any name with a space, which the
    // name fields themselves accept (isNameValid), without saying anything at all.
    const nativeValid = form.checkValidity();
    if (
      !nativeValid ||
      !isNameValid(regForm?.firstName) ||
      // #287: last name is optional, as on Manager registration and in the API
      !isLastNameValid(regForm?.lastName) ||
      emailFormatInvalid ||
      !isPasswordValid(regForm?.password) ||
      err
    ) {
      return;
    }

    const data = [
      {
        firstName: regForm?.firstName.trim(),
        lastName: regForm?.lastName.trim(),
        emailId: regForm?.emailId,
        RoleId: 4,
        password: regForm?.password,
        confirmPassword: regForm?.confirmPassword,
      },
    ];

    // #108: replaced by the single check above.
    // var mailformat = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
    // var nameFormat = /^[A-Za-z]+$/; // Only allows letters (no spaces or special characters)
    //
    // if (
    //   regForm?.emailId?.match(mailformat) &&
    //   regForm?.firstName?.match(nameFormat) &&
    //   regForm?.lastName?.match(nameFormat)
    // ) {
    setErrMessage(false);
    try {
      await UserReg(data).then((response) => {
        // #108: UserReg returns the whole axios response, and a refusal such as "Player already
        // registered with this email id" is HTTP 200 with status false in the body - so the
        // refusal was shown as a green success toast and the user was sent Home. A validation
        // 400 fell into an empty else and nothing appeared at all.
        // if (response?.status === 200) {
        if (response?.data?.status === true) {
          // #111: sign-up does not sign anyone in, so the confirmation says what to do next.
          // The server's "Player registered successfully." left that to guesswork. Email
          // verification: the account cannot sign in until its email is verified, so it says
          // where the link went - or, when it could not be sent, how to get one.
          // toast.success(response?.data?.message, {
          toast.success(signUpMessage(response.data, regForm?.emailId), {
            toastId: "success1",
            autoClose: 10000,
          });
          navigate("/Home");
        } else {
          toast.error(
            response?.data?.message ||
              response?.data?.title ||
              "Registration failed. Please try again.",
            { toastId: "error1" }
          );
        }
      });
    } catch (error) {
      toast.error(error?.response?.data?.title, {
        toastId: "error1",
      });
    }
    // } else {
    //   setErrMessage(true);
    // }
  };

  // #108: type="email" accepts "a@b"; this is the stricter rule (#274: the shared one). Rendered
  // on the field from the same value, so what blocks the submit is what is shown.
  const emailFormatInvalid = !!regForm?.emailId && !isValidEmail(regForm.emailId);

  const show = (event) => {
    setVisible(!visible);
  };
  const showConfirm = () => {
    setVisiblePass(!visiblePass);
  };

  const handelChange = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value,
    });
  };

  const handleChange = (e) => {
    // #253: the name fields only; apostrophes and hyphens are allowed too ("O'Neil", "Smith-Jones").
    const inputValue = e.target.value.replace(/[^a-zA-Z\s'-]/g, "");
    // #287: checked on every change, so a pasted value (no key pressed) shows the message too.
    if (e.target.name === "firstName") setFirstNameError(isNameValid(inputValue));
    if (e.target.name === "lastName") setLastNameError(isLastNameValid(inputValue));
    setRegForm({
      ...regForm,
      [e.target.name]: inputValue,
    });
  };

  const validateEmail = (e) => {
    const email = e.target.value;

    if (validator.isEmail(email)) {
      setMessage("");
    } else {
    }

    setRegForm({
      ...regForm,
      emailId: e.target.value,
    });
    const value = e.target.value;

    const EmailExist = value.match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

    if (EmailExist) {
      selectEmail(value);
    }
  };

  async function selectEmail(email) {
    const data = {
      email: email,
    };
    await EmailCheck(data).then((res) => {
      if (res?.data?.status == true) {
        toast.error(res?.data?.message);
      } else {
      }
    });
  }
  const handelformPass = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value.trim(),
    });

    setIsValid(isPasswordValid(e.target.value));
  };
  const handelformPassConfirm = (e) => {
    setRegForm({
      ...regForm,
      [e.target.name]: e.target.value.trim(),
    });
  };

  useEffect(() => {
    setErr(passwordsDiffer(regForm?.password, regForm?.confirmPassword) ? PASSWORDS_MISMATCH : "");
  }, [regForm?.password, regForm?.confirmPassword]);

  // #274: the shared rule, which Player.Password's RegularExpression applies too (8+ characters).
  const isPasswordValid = isValidPassword;
  // #253: the shared rule, which also allows apostrophes and hyphens ("O'Neil", "Smith-Jones").
  const isNameValid = isValidName;
  const isLastNameValid = (name) => !name || isNameValid(name);

  const handleKeyDown = (e) => {
    if (e.key === " ") {
      e.preventDefault();
    }
  };
  return (
    <>
      <div className="grop-section">
        <div className="icon-back">
          <BackButton />
        </div>
        <div className="group-reg">
          <div className="item">
            <div className="inner-item">
              <div className="form-contnet">
                <div>
                  <Link to="/Home">
                    {" "}
                    <img src="../image/logo1.png" className="logo-mob-img" />
                  </Link>
                  <h1 className="heading">Get Started Now</h1>

                  <p>Create a new account </p>
                </div>
              </div>
              <Form
                noValidate
                validated={validated}
                className="registration"
                onSubmit={handleSubmit}
              >
                <Row className="mb-3">
                  <Form.Group
                    as={Col}
                    md="6"
                    controlId="validationCustomFristname"
                  >
                    <Form.Label>First name</Form.Label>{" "}
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "-1px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        name="firstName"
                        onChange={handleChange}
                        value={regForm?.firstName}
                        onKeyPress={(e) => {
                          if (
                            e.key === " " &&
                            (regForm?.firstName.trim() === "" ||
                              e.target.selectionStart === 0)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter your first name"
                        aria-describedby="inputGroupPrepend"
                        pattern={NAME_PATTERN}
                        required
                        isInvalid={!firstNameError}
                      />
                      <Form.Control.Feedback type="invalid">
                        {personNameError("first name", regForm?.firstName)}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="6" className="text-left">
                    <Form.Label>Last name</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        name="lastName"
                        onChange={handleChange}
                        value={regForm?.lastName}
                        onKeyPress={(e) => {
                          if (
                            e.key === " " &&
                            (regForm?.lastName.trim() === "" ||
                              e.target.selectionStart === 0)
                          ) {
                            e.preventDefault();
                          }
                        }}
                        placeholder="Enter your last name"
                        aria-describedby="inputGroupPrepend"
                        // #287: optional, so an empty value passes; anything typed follows the rule.
                        pattern={NAME_PATTERN}
                        isInvalid={!lastNameError}
                      />
                      <Form.Control.Feedback type="invalid">
                        {personNameError("last name", regForm?.lastName)}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="text-left">
                    <Form.Label>Email</Form.Label>{" "}
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "-1px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="email"
                        maxlength="50"
                        onChange={validateEmail}
                        name="emailId"
                        value={regForm?.emailId}
                        onKeyDown={handleKeyDown}
                        placeholder="Enter your email"
                        autocomplete="off"
                        required
                        // #108: the stricter format check used to fail silently.
                        isInvalid={validated && emailFormatInvalid}
                      />
                      <Form.Control.Feedback type="invalid">
                        {emailError(regForm?.emailId)}
                      </Form.Control.Feedback>
                      <p
                        style={{
                          color: "#dc3545",
                          width: "100%",
                          marginTop: "5px",
                        }}
                      >
                        {message}
                      </p>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="12">
                    <Form.Label>Password</Form.Label>{" "}
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "-1px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={visible ? "text" : "password"}
                        onChange={handelformPass}
                        value={regForm?.password}
                        name="password"
                        onPaste={(e) => {
                          setVal(e.target.value.trim());
                        }}
                        onCopy={(e) => {
                          setVal(e.target.value.trim());
                        }}
                        maxLength={20}
                        placeholder="Enter password"
                        aria-describedby="inputGroupPrepend"
                        isInvalid={!isValid}
                        autoComplete="new-password"
                        required
                      />
                      <PasswordToggle visible={visible} onToggle={show} />

                      <Form.Control.Feedback type="invalid">
                        {passwordError(regForm?.password)}
                      </Form.Control.Feedback>
                      {/* #258: the rules are shown before input; the error above replaces them once the
                          password is invalid, or empty on a submit. */}
                      {isValid && !(validated && !regForm?.password) && (
                        <Form.Text className="form-hint w-100">{PASSWORD_HINT}</Form.Text>
                      )}
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="12" className="text-left">
                    <Form.Label>Confirm Password</Form.Label>{" "}
                    <span
                      style={{
                        color: "#f44336",
                        fontSize: "20px",
                        marginLeft: "-1px",
                      }}
                    >
                      *
                    </span>
                    <InputGroup hasValidation>
                      <Form.Control
                        type={visiblePass ? "text" : "password"}
                        name="confirmPassword"
                        autocomplete="on"
                        maxLength={20}
                        onChange={handelformPassConfirm}
                        value={regForm?.confirmPassword}
                        placeholder="Enter confirm password"
                        required
                      />
                      <PasswordToggle visible={visiblePass} onToggle={showConfirm} />
                      {err ? (
                        <p className="err-message">{err}</p>
                      ) : (
                        <Form.Control.Feedback type="invalid">
                          {CONFIRM_PASSWORD_REQUIRED}
                        </Form.Control.Feedback>
                      )}
                    </InputGroup>
                  </Form.Group>
                  <Col md="12">
                    <Button type="submit" className="submit">
                      Submit
                    </Button>
                  </Col>
                </Row>
              </Form>
              <p className="account-para">
                Already have an account? <a href="/Login">Login here</a>
              </p>
            </div>
          </div>
          <RightSideBanner />
        </div>
      </div>
    </>
  );
}
export default UserRegistration;
